define('calculatorUtils',[
  'module',
  'settings'
], function (
  module,
  Settings
) {
  'use strict';

  var SAFE_EXPR = /^[\d\.\+\-\*\/\(\)\s]+$/;
  var CALC_COLOR = 'orange';

  function onInputCapture(e) {
    if (Settings.configValue('advancedMode') !== true) return;

    var el = e.target;

    if (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA') {
      return;
    }

    var val = (el.value || '').replace(/^\s+|\s+$/g, '');

    if (val.charAt(0) === '=') {
      el.style.color = CALC_COLOR;
    } else if (el.style.color === CALC_COLOR) {
      el.style.color = '';
    }
  }

  function onChangeCapture(e) {
    if (Settings.configValue('advancedMode') !== true) return;

    var el = e.target;

    if (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA') {
      return;
    }

    var val = (el.value || '').replace(/^\s+|\s+$/g, '');

    if (val.charAt(0) !== '=') {
      return;
    }

    var expr = val.substring(1).replace(/,/g, '.');

    if (!SAFE_EXPR.test(expr)) {
      return;
    }

    try {
      /* jshint -W054 */
      var result = new Function('return ' + expr)();
      if (typeof result === 'number' && isFinite(result)) {
        el.value = result;
        el.style.color = '';
      }
    } catch (err) {
      // invalid expression, leave value as-is
    }
  }

  module.exports = {
    init: function () {
      document.addEventListener('input', onInputCapture, true);
      document.addEventListener('change', onChangeCapture, true);
    }
  };
});

